import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { LeituraEstacaoDialogComponent } from 'src/app/shared/leitura-estacao-dialog/leitura-estacao-dialog.component';
import { Router } from '@angular/router';
import { Table } from 'primeng/table';
import * as moment from 'moment';
import { ResumoEventoDiaService } from 'src/services/resumo-evento.service';
import { PermissoesService } from 'src/services/permissoes.service';
import { EstacaoService } from 'src/services/estacao.service';
import { TipoEventoService } from 'src/services/tipo-evento.service';
import { EstacaoGrupoService } from 'src/services/estacao-grupos.service';
import { PessoaService } from 'src/services/pessoa.service';
import { SensorService } from 'src/services/sensor.service';
import { IntegracaoService } from 'src/services/integracao.service';
import { ColetaService } from 'src/services/coleta.service';
import { normalizarDialogEstacao } from 'src/app/shared/evento-total';

type FiltroOpcao = { label?: string; value?: any; id?: any; descricao?: string };

@Component({
    selector: 'app-relatorio-eventos-analitico',
    templateUrl: './relatorio-eventos-analitico.component.html',
    styleUrls: ['./relatorio-eventos-analitico.component.scss'],
    standalone: false
})
export class RelatorioEventosAnaliticoComponent implements OnInit {
  @ViewChild(LeituraEstacaoDialogComponent) leituraEstacaoDialog?: LeituraEstacaoDialogComponent;
  @ViewChild('detalhesTable') detalhesTable?: Table;
  @ViewChild('relatorioGraficoPagina1') relatorioGraficoPagina1?: ElementRef<HTMLDivElement>;
  @ViewChild('relatorioGraficoPagina2') relatorioGraficoPagina2?: ElementRef<HTMLDivElement>;
  @ViewChild('relatorioGraficoPagina3') relatorioGraficoPagina3?: ElementRef<HTMLDivElement>;

  loading = false;
  loadingDialogEstacao = false;
  modalEstacao = false;
  modalRelatorioGrafico = false;
  rangeDate: any[] = [];
  navigationState: any;
  dataGeracao = '';
  periodoFormatado = '';
  globalFilter = '';
  exibirFiltroAvancado = false;
  tituloModalEstacao = '';
  dataRotaModal = '';
  estacaoDialog: any = null;
  dadosDialogEstacao: any[] = [];
  exportandoGraficoPdf = false;

  indicadoresGerenciais: Array<{ label: string; valor: string; destaque: string }> = [];
  insightsGerenciais: Array<{ titulo: string; descricao: string }> = [];
  graficoTiposData: any = null;
  graficoTiposOptions: any = null;
  graficoEstacoesData: any = null;
  graficoEstacoesOptions: any = null;
  graficoLinhaData: any = null;
  graficoLinhaOptions: any = null;
  graficoClientesData: any = null;
  graficoClientesOptions: any = null;

  dropDownEstacao: any[] = [];
  dropDownTipoEvento: any[] = [];
  dropDownGrupos: any[] = [];
  dropDownClientes: any[] = [];
  dropDownSensores: any[] = [];
  dropDownIntegradores: any[] = [];
  dropDownColetores: any[] = [];

  filtrosAplicados: any = {
    estacoes: [],
    grupos: [],
    clientes: [],
    sensores: [],
    tiposEvento: [],
    integradores: [],
    coletores: [],
    plu: null,
    flu: null,
    somenteSituacaoEventoUm: true,
  };

  resumo = {
    total_estacoes_filtradas: 0,
    total_estacoes_com_evento: 0,
    total_eventos: 0,
    total_tipos_com_evento: 0,
  };

  porTipo: any[] = [];
  detalhes: any[] = [];

  constructor(
    private router: Router,
    private resumoEventoService: ResumoEventoDiaService,
    private permissaoService: PermissoesService,
    private estacaoService: EstacaoService,
    private tipoEventoService: TipoEventoService,
    private estacaoGrupoService: EstacaoGrupoService,
    private pessoaService: PessoaService,
    private sensorService: SensorService,
    private integracaoService: IntegracaoService,
    private coletaService: ColetaService
  ) {
    const navigation = this.router.getCurrentNavigation();
    this.navigationState = navigation?.extras?.state || history.state;
  }

  ngOnInit(): void {
    if (!this.permissaoService.can('monitoramento_visualizar')) {
      this.router.navigate(['/notfound']);
      return;
    }

    this.rangeDate = this.navigationState?.rangeDate || [];
    this.filtrosAplicados = {
      estacoes: this.navigationState.estacao_id || [],
      grupos: this.navigationState.grupo || [],
      clientes: this.navigationState.cliente || [],
      sensores: this.navigationState.sensor || [],
      tiposEvento: this.navigationState.tipo_evento_ids || [],
      integradores: this.navigationState.integrador_filtro || [],
      coletores: this.navigationState.coletor_filtro || [],
      plu: this.navigationState.plu_filtro || null,
      flu: this.navigationState.flu_filtro || null,
      somenteSituacaoEventoUm: this.navigationState.somente_situacao_evento_1 ?? true,
    };

    this.dataGeracao = moment().format('DD/MM/YYYY [às] HH:mm');
    this.listEstacoes();
    this.listTiposEvento();
    this.listGrupos();
    this.listClientes();
    this.listSensores();
    this.listIntegradores();
    this.listColetores();

    if (this.rangeDate.length >= 2) {
      this.atualizarPeriodoFormatado();
      this.carregarDados();
    }
  }

  carregarDados(): void {
    if (!this.rangeDate || this.rangeDate.length < 2) {
      return;
    }

    this.loading = true;
    this.atualizarPeriodoFormatado();

    this.resumoEventoService.filterRelatorioAnalitico(
      moment(this.rangeDate[0]).format('YYYY-MM-DD'),
      moment(this.rangeDate[1]).format('YYYY-MM-DD'),
      this.extrairIds(this.filtrosAplicados.estacoes),
      this.extrairIds(this.filtrosAplicados.grupos),
      this.extrairIds(this.filtrosAplicados.clientes),
      this.extrairIds(this.filtrosAplicados.sensores),
      this.filtrosAplicados.plu,
      this.filtrosAplicados.flu,
      this.extrairIds(this.filtrosAplicados.integradores),
      this.extrairIds(this.filtrosAplicados.coletores),
      this.extrairIds(this.filtrosAplicados.tiposEvento),
      this.filtrosAplicados.somenteSituacaoEventoUm
    ).subscribe({
      next: (response: any) => {
        this.resumo = response?.resumo || this.resumo;
        this.porTipo = response?.por_tipo || [];
        this.detalhes = (response?.detalhes || []).map((item: any) => ({
          ...item,
          data_formatada: moment(item.data_resumo).format('DD/MM/YYYY'),
          status_label: Number(item.situaca_evento) === 0 ? 'Sem evento' : 'Evento registrado'
        }));
        this.atualizarRelatorioGrafico();
        this.loading = false;
      },
      error: () => {
        this.atualizarRelatorioGrafico();
        this.loading = false;
      }
    });
  }

  toggleFiltroAvancado(): void {
    this.exibirFiltroAvancado = !this.exibirFiltroAvancado;
  }

  private atualizarPeriodoFormatado(): void {
    if (this.rangeDate?.length >= 2) {
      this.periodoFormatado = `${moment(this.rangeDate[0]).format('DD/MM/YYYY')} a ${moment(this.rangeDate[1]).format('DD/MM/YYYY')}`;
    } else {
      this.periodoFormatado = '';
    }
  }

  listEstacoes(): void {
    this.dropDownEstacao = [];
    this.estacaoService.lookup().subscribe(json => {
      (json || []).forEach((item: any) => {
        this.dropDownEstacao.push({ label: item.descricao, value: item.id });
      });
      this.dropDownEstacao.sort((a, b) =>
        a.label.localeCompare(b.label, 'pt-BR', { sensitivity: 'base' })
      );
    });
  }

  listTiposEvento(): void {
    this.dropDownTipoEvento = [];
    this.tipoEventoService.listar().subscribe(json => {
      (json || []).forEach((item: any) => {
        this.dropDownTipoEvento.push({ label: item.descricao, value: item.id });
      });
      this.dropDownTipoEvento.sort((a, b) =>
        a.label.localeCompare(b.label, 'pt-BR', { sensitivity: 'base' })
      );
    });
  }

  listGrupos(): void {
    this.dropDownGrupos = [];
    this.estacaoGrupoService.index().subscribe(json => {
      (json || []).forEach((item: any) => {
        this.dropDownGrupos.push({ label: item.nome, value: item.id });
      });
    });
  }

  listClientes(): void {
    this.dropDownClientes = [];
    this.pessoaService.index().subscribe(json => {
      (json || []).filter((item: any) => item.ativo === true).forEach((item: any) => {
        this.dropDownClientes.push({ label: item.nome, value: item.id });
      });
    });
  }

  listSensores(): void {
    this.dropDownSensores = [];
    this.sensorService.index().subscribe(json => {
      (json || []).forEach((item: any) => {
        this.dropDownSensores.push({ label: item.descricao, value: item.id });
      });
    });
  }

  listIntegradores(): void {
    this.dropDownIntegradores = [];
    this.integracaoService.index().subscribe(json => {
      (json || []).forEach((item: any) => {
        this.dropDownIntegradores.push({ label: item.descricao, value: item.id });
      });
    });
  }

  listColetores(): void {
    this.dropDownColetores = [];
    this.coletaService.index().subscribe(json => {
      (json || []).forEach((item: any) => {
        this.dropDownColetores.push({ descricao: item.descricao, id: item.id });
      });
    });
  }

  private extrairIds(items: FiltroOpcao[] = []): any[] {
    return (items || [])
      .map((item: FiltroOpcao) => item?.value ?? item?.id ?? item)
      .filter((value: any) => value != null);
  }

  getDescricaoFiltros(): string {
    const partes: string[] = [];

    this.adicionarParteFiltro(partes, 'Estações', this.filtrosAplicados.estacoes);
    this.adicionarParteFiltro(partes, 'Grupos', this.filtrosAplicados.grupos);
    this.adicionarParteFiltro(partes, 'Clientes', this.filtrosAplicados.clientes);
    this.adicionarParteFiltro(partes, 'Sensores', this.filtrosAplicados.sensores);
    this.adicionarParteFiltro(partes, 'Tipos de evento', this.filtrosAplicados.tiposEvento);
    this.adicionarParteFiltro(partes, 'Integradores', this.filtrosAplicados.integradores);
    this.adicionarParteFiltro(partes, 'Coletores', this.filtrosAplicados.coletores);

    if (this.filtrosAplicados.plu) {
      partes.push(`PLU: ${this.filtrosAplicados.plu}`);
    }
    if (this.filtrosAplicados.flu) {
      partes.push(`FLU: ${this.filtrosAplicados.flu}`);
    }
    return partes.length > 0 ? partes.join(' | ') : 'Todos os registros filtrados';
  }

  private adicionarParteFiltro(partes: string[], titulo: string, itens: FiltroOpcao[]): void {
    if (!itens || itens.length === 0) {
      return;
    }

    const valores = itens.map((item: FiltroOpcao) => item?.label || item?.descricao || item?.value || item).join(', ');
    partes.push(`${titulo}: ${valores}`);
  }

  aplicarFiltroGlobal(event: Event): void {
    const valor = (event.target as HTMLInputElement).value;
    this.globalFilter = valor;
    this.detalhesTable?.filterGlobal(valor, 'contains');
  }

  abrirRelatorioGrafico(): void {
    this.modalRelatorioGrafico = true;
  }

  abrirDialogEstacao(row: any): void {
    const estacaoId = Number(row?.estacao_id);
    const dataResumo = moment(row?.data_resumo).format('YYYY-MM-DD');

    if (!estacaoId || !dataResumo || dataResumo === 'Invalid date') {
      return;
    }

    this.modalEstacao = true;
    this.loadingDialogEstacao = true;
    this.dataRotaModal = dataResumo;
    this.tituloModalEstacao = `${row.estacao_descricao || 'Estação'} - ${moment(dataResumo).format('DD/MM/YYYY')}`;

    this.resumoEventoService.mapDialog(estacaoId, dataResumo).subscribe({
      next: (json: any) => {
        const dialogo = normalizarDialogEstacao(json);
        this.estacaoDialog = dialogo;
        this.dadosDialogEstacao = dialogo ? [dialogo] : [];
        this.tituloModalEstacao = `${json?.descricao || row.estacao_descricao || 'Estação'} - ${moment(dataResumo).format('DD/MM/YYYY')}`;
        this.loadingDialogEstacao = false;
      },
      error: () => {
        this.estacaoDialog = null;
        this.dadosDialogEstacao = [];
        this.loadingDialogEstacao = false;
      }
    });
  }

  changeDateDialogEstacao(direcao: 'amanha' | 'ontem'): void {
    if (!this.estacaoDialog?.id || !this.dataRotaModal) {
      return;
    }

    const base = moment(this.dataRotaModal, 'YYYY-MM-DD');
    this.dataRotaModal = direcao === 'amanha'
      ? base.add(1, 'day').format('YYYY-MM-DD')
      : base.subtract(1, 'day').format('YYYY-MM-DD');

    this.abrirDialogEstacao({
      estacao_id: this.estacaoDialog.id,
      estacao_descricao: this.estacaoDialog.descricao,
      data_resumo: this.dataRotaModal
    });
  }

  abrirLeiturasEstacao(): void {
    const estacaoId = Number(this.estacaoDialog?.id);
    const dataResumo = this.dataRotaModal;

    if (!estacaoId || !dataResumo) {
      return;
    }

    this.leituraEstacaoDialog?.abrir({
      estacaoId,
      dataResumo,
      estacaoDescricao: this.estacaoDialog?.descricao,
    });
  }

  getIconeEvento(row: any): string {
    if (Number(row?.tipo_evento_id) === 9) {
      return 'pi pi-exclamation-triangle';
    }
    return row?.tipo_evento?.icone || row?.icone || '';
  }

  getIconeMonitoramento(row: any): string {
    if (Number(row?.tipo_evento_id) === 9) {
      return 'pi pi-exclamation-triangle';
    }
    return row?.icone || row?.tipo_evento?.icone || '';
  }

  getQuantidadeLista(row: any): number {
    if (row?.quantidade_eventos_lista != null) {
      return Number(row.quantidade_eventos_lista) || 0;
    }

    if (row?.total_computado_irregular != null) {
      return Number(row.total_computado_irregular) || 0;
    }

    return Number(row?.quantidade_eventos_dia) || 0;
  }

  voltar(): void {
    this.router.navigate(['/monitoramento-estacoes'], {
      state: {
        rangeDate: this.rangeDate,
        estacao_id: this.navigationState?.estacao_id,
        grupo: this.navigationState?.grupo,
        cliente: this.navigationState?.cliente,
        sensor: this.navigationState?.sensor,
        plu_filtro: this.navigationState?.plu_filtro,
        flu_filtro: this.navigationState?.flu_filtro,
        integrador_filtro: this.navigationState?.integrador_filtro,
        coletor_filtro: this.navigationState?.coletor_filtro,
        tipo_evento_ids: this.navigationState?.tipo_evento_ids,
        somente_situacao_evento_1: this.filtrosAplicados.somenteSituacaoEventoUm
      }
    });
  }

  exportarExcel(): void {
    const resumoSheet = [
      {
        'Período': this.periodoFormatado,
        'Total estações filtradas': this.resumo.total_estacoes_filtradas,
        'Total estações com evento': this.resumo.total_estacoes_com_evento,
        'Total eventos': this.resumo.total_eventos,
        'Total tipos com evento': this.resumo.total_tipos_com_evento,
        'Filtros': this.getDescricaoFiltros()
      }
    ];

    const porTipoSheet = this.porTipo.map((item: any) => ({
      'Tipo de evento': item.tipo_evento_descricao,
      'Total de eventos': item.total_eventos,
      'Estações com evento': item.total_estacoes_com_evento,
      'Dias com evento': item.total_dias_com_evento
    }));

    const detalhesSheet = this.detalhes.map((item: any) => ({
      'Data': item.data_formatada,
      'Estação': item.estacao_descricao,
      'Cliente': item.cliente_nome || '',
      'Tipo de evento': item.tipo_evento_descricao,
      'Quantidade no dia': this.getQuantidadeLista(item),
      'Status': item.status_label
    }));

    import('xlsx').then(xlsx => {
      const workbook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(workbook, xlsx.utils.json_to_sheet(resumoSheet), 'Resumo');
      xlsx.utils.book_append_sheet(workbook, xlsx.utils.json_to_sheet(porTipoSheet), 'Por Tipo');
      xlsx.utils.book_append_sheet(workbook, xlsx.utils.json_to_sheet(detalhesSheet), 'Detalhes');
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, 'Relatorio_Analitico_Eventos');
    });
  }

  exportarPDF(): void {
    import('jspdf').then(jsPDF => {
      import('jspdf-autotable').then((autoTableModule: any) => {
        const doc = new jsPDF.default('portrait', 'mm', 'a4');
        const autoTable = autoTableModule?.default || autoTableModule?.autoTable;
        const marginLeft = 14;
        let cursorY = 18;

        if (typeof autoTable !== 'function') {
          throw new Error('Nao foi possivel carregar o modulo de exportacao PDF.');
        }

        doc.setFontSize(16);
        doc.text('MITSAT - Relatório Analítico de Eventos', marginLeft, cursorY);
        cursorY += 8;

        doc.setFontSize(10);
        doc.text(`Gerado em: ${this.dataGeracao}`, marginLeft, cursorY);
        cursorY += 5;
        doc.text(`Período: ${this.periodoFormatado}`, marginLeft, cursorY);
        cursorY += 5;

        const filtrosLinhas = doc.splitTextToSize(`Filtros: ${this.getDescricaoFiltros()}`, 180);
        doc.text(filtrosLinhas, marginLeft, cursorY);
        cursorY += filtrosLinhas.length * 5 + 2;

        autoTable(doc, {
          startY: cursorY,
          head: [['Indicador', 'Valor']],
          body: [
            ['Estações filtradas', String(this.resumo.total_estacoes_filtradas)],
            ['Estações com evento', String(this.resumo.total_estacoes_com_evento)],
            ['Total de eventos', String(this.resumo.total_eventos)],
            ['Tipos com evento', String(this.resumo.total_tipos_com_evento)]
          ],
          margin: { left: marginLeft, right: marginLeft }
        });

        cursorY = (doc as any).lastAutoTable.finalY + 8;
        autoTable(doc, {
          startY: cursorY,
          head: [['Tipo de evento', 'Total eventos', 'Estações', 'Dias']],
          body: this.porTipo.map((item: any) => [
            item.tipo_evento_descricao,
            String(item.total_eventos),
            String(item.total_estacoes_com_evento),
            String(item.total_dias_com_evento)
          ]),
          margin: { left: marginLeft, right: marginLeft }
        });

        cursorY = (doc as any).lastAutoTable.finalY + 8;
        autoTable(doc, {
          startY: cursorY,
          head: [['Data', 'Estação', 'Cliente', 'Evento', 'Qtde', 'Status']],
          body: this.detalhes.map((item: any) => [
            item.data_formatada,
            item.estacao_descricao,
            item.cliente_nome || '-',
            item.tipo_evento_descricao,
            String(this.getQuantidadeLista(item)),
            item.status_label
          ]),
          styles: { fontSize: 8 },
          margin: { left: marginLeft, right: marginLeft }
        });

        doc.save(`Relatorio_Analitico_Eventos_${moment().format('YYYYMMDD_HHmmss')}.pdf`);
      });
    });
  }

  exportarRelatorioGraficoPDF(): void {
    const paginas = [
      this.relatorioGraficoPagina1?.nativeElement,
      this.relatorioGraficoPagina2?.nativeElement,
      this.relatorioGraficoPagina3?.nativeElement
    ].filter((element): element is HTMLDivElement => !!element);

    if (!paginas.length || !this.temDadosGraficos()) {
      return;
    }

    this.exportandoGraficoPdf = true;

    import('html2canvas').then((html2canvasModule: any) => {
      import('jspdf').then(async jsPDF => {
        const html2canvas = html2canvasModule?.default || html2canvasModule;
        const doc = new jsPDF.default('landscape', 'mm', 'a4');
        const margin = 10;
        const pageWidth = 297 - (margin * 2);
        const pageHeight = 210 - (margin * 2);

        try {
          for (let index = 0; index < paginas.length; index++) {
            const element = paginas[index];
            const canvas = await html2canvas(element, {
              backgroundColor: '#ffffff',
              scale: 2,
              useCORS: true,
              logging: false,
              windowWidth: element.scrollWidth
            });

            if (index > 0) {
              doc.addPage();
            }

            this.adicionarImagemCentralizadaNoPdf(doc, canvas, margin, pageWidth, pageHeight);
          }

          doc.save(`Relatorio_Grafico_Eventos_${moment().format('YYYYMMDD_HHmmss')}.pdf`);
        } catch {
          // Mantém o fluxo silencioso como no export anterior.
        } finally {
          this.exportandoGraficoPdf = false;
        }
      }).catch(() => {
        this.exportandoGraficoPdf = false;
      });
    }).catch(() => {
      this.exportandoGraficoPdf = false;
    });
  }

  private adicionarImagemCentralizadaNoPdf(
    doc: any,
    canvas: HTMLCanvasElement,
    margin: number,
    pageWidth: number,
    pageHeight: number
  ): void {
    const imgData = canvas.toDataURL('image/png');
    let imgWidth = pageWidth;
    let imgHeight = (canvas.height * pageWidth) / canvas.width;

    if (imgHeight > pageHeight) {
      imgHeight = pageHeight;
      imgWidth = (canvas.width * pageHeight) / canvas.height;
    }

    const x = margin + ((pageWidth - imgWidth) / 2);
    const y = margin + ((pageHeight - imgHeight) / 2);

    doc.addImage(imgData, 'PNG', x, y, imgWidth, imgHeight, undefined, 'FAST');
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then(FileSaver => {
      const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      const EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
      FileSaver.default.saveAs(data, fileName + '_' + moment().format('YYYYMMDD_HHmmss') + EXCEL_EXTENSION);
    });
  }

  temDadosGraficos(): boolean {
    return this.detalhes.length > 0 || this.porTipo.length > 0;
  }

  private atualizarRelatorioGrafico(): void {
    if (!this.temDadosGraficos()) {
      this.indicadoresGerenciais = [];
      this.insightsGerenciais = [];
      this.graficoTiposData = null;
      this.graficoTiposOptions = null;
      this.graficoEstacoesData = null;
      this.graficoEstacoesOptions = null;
      this.graficoLinhaData = null;
      this.graficoLinhaOptions = null;
      this.graficoClientesData = null;
      this.graficoClientesOptions = null;
      return;
    }

    const totaisPorTipo = this.porTipo
      .map((item: any) => ({
        label: item.tipo_evento_descricao || 'Não informado',
        total: Number(item.total_eventos) || 0,
        estacoes: Number(item.total_estacoes_com_evento) || 0,
        dias: Number(item.total_dias_com_evento) || 0
      }))
      .sort((a, b) => b.total - a.total);

    const detalhesComQuantidade = this.detalhes.map((item: any) => ({
      ...item,
      quantidade: this.getQuantidadeLista(item),
      dataKey: moment(item.data_resumo).format('YYYY-MM-DD'),
      dataLabel: moment(item.data_resumo).format('DD/MM')
    }));

    const totaisPorEstacao = this.agruparTotais(
      detalhesComQuantidade,
      (item: any) => item.estacao_descricao || 'Estação não informada'
    );
    const totaisPorCliente = this.agruparTotais(
      detalhesComQuantidade.filter((item: any) => !!item.cliente_nome),
      (item: any) => item.cliente_nome || 'Cliente não informado'
    );
    const totaisPorData = this.agruparTotais(
      detalhesComQuantidade,
      (item: any) => item.dataKey
    );

    const estacoesComEvento = this.resumo.total_estacoes_com_evento || 0;
    const estacoesFiltradas = this.resumo.total_estacoes_filtradas || 0;
    const diasNoPeriodo = this.rangeDate?.length >= 2
      ? Math.max(moment(this.rangeDate[1]).diff(moment(this.rangeDate[0]), 'days') + 1, 1)
      : 1;
    const picoDiario = totaisPorData[0]?.total || 0;
    const taxaImpacto = estacoesFiltradas > 0 ? (estacoesComEvento / estacoesFiltradas) * 100 : 0;

    this.indicadoresGerenciais = [
      {
        label: 'Total de eventos',
        valor: this.formatarNumero(this.resumo.total_eventos),
        destaque: 'Volume consolidado no período filtrado'
      },
      {
        label: 'Estações impactadas',
        valor: `${this.formatarNumero(estacoesComEvento)} / ${this.formatarNumero(estacoesFiltradas)}`,
        destaque: `${taxaImpacto.toFixed(1)}% das estações filtradas tiveram ocorrência`
      },
      {
        label: 'Média diária',
        valor: this.formatarDecimal((this.resumo.total_eventos || 0) / diasNoPeriodo),
        destaque: 'Eventos por dia no período selecionado'
      },
      {
        label: 'Pico diário',
        valor: this.formatarNumero(picoDiario),
        destaque: totaisPorData[0]?.label ? `Maior concentração em ${moment(totaisPorData[0].label).format('DD/MM/YYYY')}` : 'Sem pico identificado'
      }
    ];

    this.insightsGerenciais = [
      this.criarInsight('Evento líder', totaisPorTipo[0], 'ocorrências'),
      this.criarInsight('Estação mais impactada', totaisPorEstacao[0], 'eventos'),
      this.criarInsight(
        'Dia mais crítico',
        totaisPorData[0] ? { ...totaisPorData[0], label: moment(totaisPorData[0].label).format('DD/MM/YYYY') } : null,
        'eventos'
      ),
      this.criarInsight('Cliente mais impactado', totaisPorCliente[0], 'eventos')
    ].filter((item: any) => !!item);

    const palette = this.obterPaletaGrafico();
    this.graficoTiposData = this.criarGraficoBarra(
      totaisPorTipo.slice(0, 8).map(item => item.label),
      totaisPorTipo.slice(0, 8).map(item => item.total),
      'Ocorrências por tipo',
      palette.primary,
      palette.primaryBorder
    );
    this.graficoTiposOptions = this.criarOpcoesGrafico('Tipos de evento com maior volume');

    this.graficoEstacoesData = this.criarGraficoBarra(
      totaisPorEstacao.slice(0, 8).map(item => item.label),
      totaisPorEstacao.slice(0, 8).map(item => item.total),
      'Eventos por estação',
      palette.warning,
      palette.warningBorder
    );
    this.graficoEstacoesOptions = this.criarOpcoesGrafico('Estações com maior impacto', true);

    const totaisPorDataOrdenados = [...totaisPorData].sort((a, b) =>
      moment(a.label, 'YYYY-MM-DD').valueOf() - moment(b.label, 'YYYY-MM-DD').valueOf()
    );
    this.graficoLinhaData = {
      labels: totaisPorDataOrdenados.map(item => moment(item.label, 'YYYY-MM-DD').format('DD/MM')),
      datasets: [
        {
          label: 'Eventos por dia',
          data: totaisPorDataOrdenados.map(item => item.total),
          borderColor: palette.infoBorder,
          backgroundColor: palette.info,
          fill: true,
          tension: 0.35
        }
      ]
    };
    this.graficoLinhaOptions = this.criarOpcoesGrafico('Evolução diária das ocorrências', false, 16);

    this.graficoClientesData = this.criarGraficoBarra(
      totaisPorCliente.slice(0, 8).map(item => item.label),
      totaisPorCliente.slice(0, 8).map(item => item.total),
      'Eventos por cliente',
      palette.success,
      palette.successBorder,
      44
    );
    this.graficoClientesOptions = this.criarOpcoesGrafico('Clientes mais impactados', true, 16);
  }

  private agruparTotais(items: any[], getLabel: (item: any) => string): Array<{ label: string; total: number }> {
    const mapa = new Map<string, number>();

    items.forEach((item: any) => {
      const label = getLabel(item);
      const total = Number(item.quantidade ?? item.total ?? 0) || 0;
      mapa.set(label, (mapa.get(label) || 0) + total);
    });

    return Array.from(mapa.entries())
      .map(([label, total]) => ({ label, total }))
      .sort((a, b) => b.total - a.total);
  }

  private criarInsight(
    titulo: string,
    item?: { label: string; total: number } | null,
    sufixo: string = 'eventos'
  ): { titulo: string; descricao: string } | null {
    if (!item) {
      return null;
    }

    return {
      titulo,
      descricao: `${item.label}: ${this.formatarNumero(item.total)} ${sufixo}`
    };
  }

  private criarGraficoBarra(
    labels: string[],
    data: number[],
    label: string,
    backgroundColor: string,
    borderColor: string,
    maxBarThickness = 34
  ): any {
    return {
      labels,
      datasets: [
        {
          label,
          data,
          backgroundColor,
          borderColor,
          borderWidth: 1,
          borderRadius: 6,
          maxBarThickness
        }
      ]
    };
  }

  private criarOpcoesGrafico(titulo: string, horizontal = false, titleSize = 14): any {
    const palette = this.obterPaletaGrafico();

    return {
      responsive: true,
      maintainAspectRatio: false,
      indexAxis: horizontal ? 'y' : 'x',
      plugins: {
        legend: {
          display: false
        },
        title: {
          display: true,
          text: titulo,
          color: palette.textStrong,
          font: {
            size: titleSize,
            weight: '600'
          }
        }
      },
      scales: {
        x: {
          ticks: {
            color: palette.textSoft
          },
          grid: {
            color: palette.grid
          }
        },
        y: {
          beginAtZero: true,
          ticks: {
            color: palette.textSoft
          },
          grid: {
            color: palette.grid
          }
        }
      }
    };
  }

  private obterPaletaGrafico(): any {
    return {
      primary: 'rgba(21, 58, 91, 0.82)',
      primaryBorder: '#153a5b',
      warning: 'rgba(245, 158, 11, 0.82)',
      warningBorder: '#d97706',
      info: 'rgba(14, 116, 144, 0.22)',
      infoBorder: '#0e7490',
      success: 'rgba(5, 150, 105, 0.82)',
      successBorder: '#047857',
      textStrong: '#102a43',
      textSoft: '#486581',
      grid: '#d9e2ec'
    };
  }

  private formatarNumero(valor: number): string {
    return new Intl.NumberFormat('pt-BR').format(Number(valor) || 0);
  }

  private formatarDecimal(valor: number): string {
    return new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    }).format(Number(valor) || 0);
  }
}
